import { Navigate } from 'react-router-dom';
import { getUser } from '../helpers/DecodeJWT';
import { hasPrivilege, PRIVILEGE } from './privileges';

export default function HomeRedirect() {
  const user = getUser();
  const role = user?.role;

  if (hasPrivilege(role, PRIVILEGE.EVENTS)) return <Navigate to="/events" replace />;
  if (hasPrivilege(role, PRIVILEGE.RIDES)) return <Navigate to="/routes" replace />;
  if (hasPrivilege(role, PRIVILEGE.VOUCHERS)) return <Navigate to="/vouchers" replace />;
  if (hasPrivilege(role, PRIVILEGE.FINANCE)) return <Navigate to="/finance" replace />;

  // Logged in but no feature privileges.
  return <Navigate to="/dashboard" replace />;
}
